
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import SavedRxListItem from '@/views/saved-rx-list/components/SavedRxListItem.vue';
	import { SavedRxNames } from '@/store/engine/modules/SavedRxModule';
	import PrescriptionSummary from '@/components/new-prescription/prescription-summary/PrescriptionSummary.vue';

	@Observer
	@Component({
		components: { SavedRxListItem, PrescriptionSummary }
	})
	export default class SavedRxList extends Vue {
		rxList: SavedRxNames = [];

		async activated() {
			this.$state.prescription.resetPrescription();
			this.rxList = await this.$state.engine.savedRx.getRxList();
			// if (this.rxList) {
			// 	this.rxList = this.rxList.filter((item) => item.fileName !== 'Accommodative');
		}

		private async back() {
			await this.$router.push('/index');
		}

		private async newSavedRx() {
			await this.$state.prescription.resetPrescription();
			await this.$router.push('/saved-rx');
		}
	}
